// Forfaits Compétition / Compagnie : deux entraînements hebdomadaires INDISSOCIABLES
// vendus à un prix unique pour le semestre.
//
// La donnée vient du Google Sheet (colonnes FORFAIT et PRIX_FORFAIT de
// Planning_hebdomadaire) : aucun ID_COURS, aucun nom de groupe et aucun prix ne sont
// écrits ici. L'école peut donc créer un forfait, déplacer un entraînement ou changer
// le prix sans toucher au code. Si un forfait n'a pas exactement 2 entraînements actifs
// avec le même prix, le backend le neutralise (champs vidés) et les cours redeviennent
// des cours à l'unité — jamais de facturation fausse en silence.

export function forfaitOf(course) {
  const name = (course?.forfait || "").trim();
  const price = Number(course?.forfait_price);
  if (!name || !Number.isFinite(price) || price <= 0) return null;
  return { name, price };
}

// Tous les entraînements du même forfait présents dans une liste de cours.
export function forfaitSessions(course, allCourses) {
  const f = forfaitOf(course);
  if (!f) return [course];
  const same = (allCourses || []).filter((c) => forfaitOf(c)?.name === f.name);
  return same.length ? same : [course];
}

// Regroupe une sélection de cours : un forfait = UNE entrée, à son prix forfaitaire.
// Les cours à l'unité sortent SANS prix : il dépend de la personne (âge / case adulte) et
// c'est `selectionPricing()` de pricing.js qui le calcule. L'ordre d'apparition est conservé.
export function selectionGroups(courses) {
  const groups = [];
  const seen = new Map();
  (courses || []).forEach((co) => {
    if (!co) return;
    const f = forfaitOf(co);
    if (!f) {
      groups.push({ key: `course:${co.id}`, type: "course", label: co.name, price: null, courses: [co] });
      return;
    }
    const existing = seen.get(f.name);
    if (existing) {
      existing.courses.push(co);
      return;
    }
    const g = {
      key: `forfait:${f.name}`, type: "forfait", forfait: f.name,
      label: `Forfait ${f.name}`, price: f.price, courses: [co],
    };
    seen.set(f.name, g);
    groups.push(g);
  });
  return groups;
}

// Discipline « Compétition » (et « Compagnie ») : aucune réduction, ni accumulation ni
// famille. Décision de l'école du 18.08.2026 — le critère est la colonne Discipline du
// planning, pas la présence d'un forfait. Cela inclut donc « Préparation compétition
// junior » et « Duo & solo (compétition IDO) » du mercredi, vendus à l'unité.
// Comparaison sans accents ni casse : « Hip-hop » vs « Hip-Hop » nous a déjà coûté une
// alerte, on ne se fie pas à la façon dont la valeur est tapée dans le tableur.
export function estCompetition(course) {
  const d = (course?.discipline || "")
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase();
  return d.startsWith("competition") || d.startsWith("compagnie");
}

export const FORFAIT_SUBLABEL = "2 entraînements par semaine, indissociables";
